import {
    CREATE_JOB_WORK_RECEIVE,
    DELETE_JOB_WORK_RECEIVE,
    GET_JOB_WORK_RECEIVE,
    JOB_WORK_RECEIVE_REQUEST,
    JOB_WORK_RECEIVE_REQUEST_FAILURE,
    UPDATE_JOB_WORK_RECEIVE,
    GET_JOB_WORK_RECEIVES_PAGE,
    JOB_WORK_RECEIVE_REQUEST_SUCCESS,
    GET_JOB_WORK_RECEIVE_AVAILABLE_TRANSACTIONS,
    JOB_WORK_RECEIVE_TRANSACTION_AVAILABLE_REQUEST,
    JOB_WORK_RECEIVE_TRANSACTION_AVAILABLE_REQUEST_FAILURE,
    RESET_JOB_WORK_RECEIVE_AVAILABLE_TRANSACTIONS
  } from "../types/job-work-receive-types";
  
  const initialState = {
    jobWorkReceive: [],
    jobWorkReceivesPage: [],
    availableTransactions: [],
    loading: false,
    error: null,
  };
  
  const jobWorkReceiveReducer = (state = initialState, action) => {
    switch (action.type) {
      case JOB_WORK_RECEIVE_REQUEST: {
        return {
          ...state,
          loading: true,
          error: null
        }
      }
      case GET_JOB_WORK_RECEIVE: {
        return {
          ...state,
          jobWorkReceive: [...action.payload],
          loading: false,
          error: null
        }
      }
      case GET_JOB_WORK_RECEIVES_PAGE: {
        const { data, total, page, pageSize, search, where } = action.payload || {};
        return {
          ...state,
          jobWorkReceivesPage: [...data],
          total,
          page,
          pageSize,
          search: search || '',
          where: where || {},
          loading: false,
          error: null
        }
      }
      case CREATE_JOB_WORK_RECEIVE:
        return {
          ...state,
          jobWorkReceive: [action.payload, ...state.jobWorkReceive],
          loading: false,
          error: null
        };
      case UPDATE_JOB_WORK_RECEIVE:
        const jobWorkReceiveData = state.jobWorkReceive.slice(0);
        const uIndex = jobWorkReceiveData.findIndex((data) => data.id === action.payload.id);
        jobWorkReceiveData.splice(uIndex, 1, { ...action.payload.data });
        
        return {
          ...state,
          jobWorkReceive: [ ...jobWorkReceiveData ],
          loading: false,
          error: null
        };
      case DELETE_JOB_WORK_RECEIVE:
        const jobWorkReceive = state.jobWorkReceive?.slice(0);
        const index = jobWorkReceive.findIndex((data) => data.id === action.id);
        if (index > -1) {
          jobWorkReceive.splice(index, 1);
        }
        return {
          ...state,
          jobWorkReceive: [...jobWorkReceive],
          loading: false,
          error: null
        }
      case JOB_WORK_RECEIVE_REQUEST_SUCCESS: {
        return {
          ...state,
          loading: false,
          error: null
        }
      }
      case JOB_WORK_RECEIVE_REQUEST_FAILURE: {
        return {
          ...state,
          loading: false,
          error: action.error
        }
      }
      case JOB_WORK_RECEIVE_TRANSACTION_AVAILABLE_REQUEST: {
        return {
          ...state,
          loading: true,
          error: null
        }
      }
      case GET_JOB_WORK_RECEIVE_AVAILABLE_TRANSACTIONS: {
        return {
          ...state,
          availableTransactions: [ ...action.payload ],
          loading: false,
          error: null
        }
      }
      case RESET_JOB_WORK_RECEIVE_AVAILABLE_TRANSACTIONS: {
        return {
          ...state,
          availableTransactions: [],
          loading: false,
          error: null
        }
      }
      case JOB_WORK_RECEIVE_TRANSACTION_AVAILABLE_REQUEST_FAILURE: {
        return {
          ...state,
          loading: false,
          error: action.error
        }
      }
      default:
        return state;
    }
  };
  
  export default jobWorkReceiveReducer;
  